import { RequestServerClass } from '../../util/request';
import publishObjectPath from '@/util/configRegistry';
const serverUrl = publishObjectPath.serverUrl;

export class PatrolManagementServe {
  public rSerivce: any;

  constructor(opt: any, axiosFilterFn?: any) {
    this.rSerivce = new RequestServerClass(opt);
    axiosFilterFn.call(this, this.rSerivce.serverObj);
  }

  // 巡检线路

  // 巡检线路数据
  public getPatrolLineAllData(opts: object) {
    const url = serverUrl + '/api/yunnan/patrol/line';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 新增数据
  public addPatrolLine(opts: object) {
    const url = serverUrl + '/api/yunnan/patrol/line';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 修改数据
  public editPatrolLineData(id: string, opts: object) {
    const url = serverUrl + `/api/yunnan/patrol/line/${id}`;
    return this.rSerivce.serverObj.put(url, opts);
  }

  // 删除数据
  public deletePatrolLine(ids: string | string[]) {
    const url = serverUrl + `/api/yunnan/patrol/line/${ids}`;
    return this.rSerivce.serverObj.delete(url);
  }

  // 获取巡检线路列表
  public getPatrolLineListAll(opts: object) {
    const url = serverUrl + `/api/yunnan/patrol/line`;
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 巡检线路名称检验
  public patrolLineCheckName(opts: object) {
    const url = serverUrl + `/api/yunnan/patrol/line/checkName`;
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 巡检线路数据详情
  public getPatrolLineSingleData(id: string) {
    const url = serverUrl + `/api/yunnan/patrol/line/${id}`;
    return this.rSerivce.serverObj.get(url);
  }

  //   巡检点
  public getPatrolPointAllData(opts: object) {
    const url = serverUrl + '/api/yunnan/patrol/point';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  // 删除数据
  public deletePatrolPoint(ids: string | string[]) {
    const url = serverUrl + `/api/yunnan/patrol/point/${ids}`;
    return this.rSerivce.serverObj.delete(url);
  }
  //  巡检设备列表
  public getPatrolEquipData(opts: object) {
    const url = serverUrl + '/api/yunnan/patrol/equip';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  // 新增数据
  public addPatrolPoint(opts: object) {
    const url = serverUrl + '/api/yunnan/patrol/point';
    return this.rSerivce.serverObj.post(url, opts);
  }
  // 详情
  public getPatrolPointInfoData(id: any) {
    const url = serverUrl + `/api/yunnan/patrol/point/${id}`;
    return this.rSerivce.serverObj.get(url);
  }
  // 修改数据
  public editPatrolPointData(id: string, opts: object) {
    const url = serverUrl + `/api/yunnan/patrol/point/${id}`;
    return this.rSerivce.serverObj.put(url, opts);
  }

  //   巡检设备
  public getPatrolEquipAllData(opts: object) {
    const url = serverUrl + '/api/yunnan/patrol/equip';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 新增数据
  public addPatrolEquip(opts: object) {
    const url = serverUrl + '/api/yunnan/patrol/equip';
    return this.rSerivce.serverObj.post(url, opts);
  }
  // 修改数据
  public editPatrolEquipData(id: string, opts: object) {
    const url = serverUrl + `/api/yunnan/patrol/equip/${id}`;
    return this.rSerivce.serverObj.put(url, opts);
  }

  // 删除数据
  public deletePatrolEquip(ids: string | string[]) {
    const url = serverUrl + `/api/yunnan/patrol/equip/${ids}`;
    return this.rSerivce.serverObj.delete(url);
  }

  // 绑定巡检点
  public bindPoint(opts: object) {
    const url = serverUrl + '/api/yunnan/patrol/equip/point/bind';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 依据巡检设备类型选择巡检点
  public getPatrolEquipPointAllData(type: string, opts: object) {
    const url = serverUrl + `/api/yunnan/patrol/equip/point/${type}`;
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  //   巡检任务配置

  public getPatrolTaskReceiveListData(opts: object) {
    const url = serverUrl + `/api/yunnan/patrol/receive`;
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  // 新增数据
  public addPatrolTaskReceive(opts: object) {
    const url = serverUrl + '/api/yunnan/patrol/receive';
    return this.rSerivce.serverObj.post(url, opts);
  }

  //   巡检任务配置详情
  public getPatrolTaskReceiveInfoData(id: any) {
    const url = serverUrl + `/api/yunnan/patrol/receive/${id}`;
    return this.rSerivce.serverObj.get(url);
  }

  // 修改数据
  public editPatrolTaskReceiveData(id: string, opts: object) {
    const url = serverUrl + `/api/yunnan/patrol/receive/${id}`;
    return this.rSerivce.serverObj.put(url, opts);
  }
  // 删除数据
  public deletePatrolTaskReceive(ids: string | string[]) {
    const url = serverUrl + `/api/yunnan/patrol/receive/${ids}`;
    return this.rSerivce.serverObj.delete(url);
  }

  //  巡检任务
  public getPatrolTaskListData(opts: object) {
    const url = serverUrl + `/api/yunnan/patrol/task`;
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 新增数据
  public addPatrolTask(opts: object) {
    const url = serverUrl + '/api/yunnan/patrol/task';
    return this.rSerivce.serverObj.post(url, opts);
  }

  //  详情
  public getPatrolTaskInfoData(id: any) {
    const url = serverUrl + `/api/yunnan/patrol/task/${id}`;
    return this.rSerivce.serverObj.get(url);
  }

  // 修改数据
  public finishedPoint(params: any = []) {
    const url = serverUrl + '/api/yunnan/patrol/task/edit/point/finish';
    return this.rSerivce.serverObj.put(url, params);
  }

  // 删除数据
  public deletePatrolTask(ids: string | string[]) {
    if (ids instanceof Array) ids = ids.join(',');
    const url = serverUrl + `/api/yunnan/patrol/task/${ids}`;
    return this.rSerivce.serverObj.delete(url);
  }

  // 审核管理
  public getPatrolVerifyListData(opts: object) {
    const url = serverUrl + `/api/yunnan/patrol/verify`;
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 提交申请
  public addPatrolVerify(opts: object) {
    const url = serverUrl + '/api/yunnan/patrol/verify';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 详情
  public getPatrolVerifyInfoData(id: any) {
    const url = serverUrl + `/api/yunnan/patrol/verify/${id}`;
    return this.rSerivce.serverObj.get(url);
  }

  // 修改
  public editPatrolVerifyListData(id: string, opts: object) {
    const url = serverUrl + `/api/yunnan/patrol/verify/${id}`;
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  //  巡检报表
  public getPatrolReportListData(opts: object) {
    const url = serverUrl + `/api/yunnan/patrol/report/2`;
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  // 周巡检报表
  public getPatrolReportWeekListData(opts: object) {
    const url = serverUrl + `/api/yunnan/patrol/report/week`;
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  // 日巡检报表
  public getPatrolReportDayListData(opts: object) {
    const url = serverUrl + `/api/yunnan/patrol/report/day`;
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  // 月巡检报表
  public getPatrolReportMonthListData(date: string, opts?: object) {
    const url = serverUrl + `/api/yunnan/patrol/report/month/${date}`;
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // -------------- ▼ 设备巡检任务 ▼ --------------
  public devicePatrolTaskList(opts: object) {
    const url = serverUrl + `/api/yunnan/devicePatrolTask`;
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  //  详情
  public devicePatrolTaskDetail(id: any) {
    const url = serverUrl + '/api/yunnan/devicePatrolTask/' + id;
    return this.rSerivce.serverObj.get(url);
  }

  //  删除
  public devicePatrolTaskDelete(id: string) {
    const url = serverUrl + `/api/yunnan/devicePatrolTask?idList=${id}`;
    return this.rSerivce.serverObj.delete(url);
  }
  // -------------- ▲ 设备巡检任务 ▲ --------------
  // 完成点巡检
  public finishPatrolTask(opts: object) {
    const url = serverUrl + '/api/yunnan/patrol/task/set/other/way/finish';
    return this.rSerivce.serverObj.post(url, opts);
  }
  // 完成设备巡检
  public finishEquipPatrol(opts: object) {
    const url = serverUrl + '/api/yunnan/devicePatrolTask/set/other/way/finish';
    return this.rSerivce.serverObj.post(url, opts);
  }
  // -------------- ▼ 巡检方案 ▼ --------------
  // 获取巡检方案列表-分页
  public getPatrolScheduleList(opts: any) {
    const url = serverUrl + '/api/yunnan/schedule/patrol/page';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 新增巡检方案
  public addPatrolSchedule(opts: any) {
    const url = serverUrl + '/api/yunnan/schedule/patrol';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 修改巡检方案
  public editPatrolSchedule(id: string, opts: any) {
    const url = serverUrl + `/api/yunnan/schedule/patrol/${id}`;
    return this.rSerivce.serverObj.put(url, opts);
  }

  // 巡检方案详情
  public detailPatrolSchedule(id: string) {
    const url = serverUrl + `/api/yunnan/schedule/patrol/${id}`;
    return this.rSerivce.serverObj.get(url);
  }

  // 删除巡检方案
  public deletePatrolSchedule(id: string | string[]) {
    const url = serverUrl + `/api/yunnan/schedule/patrol/${id}`;
    return this.rSerivce.serverObj.delete(url);
  }
  // -------------- ▲ 巡检方案 ▲ --------------
}
